import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserContext } from '../../../../shared/services/user-context.service';
import { Router } from '@angular/router';
import { faBars} from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']

})
export class HeaderComponent implements OnInit {
  public visibleMenuSwitcher = false;

  public fullname: string = 'Horizon User';
  public username: string = '';
  public environmentName;

    //icons
    public faBars = faBars;


  constructor(
    private router: Router, 
    private userContext: UserContext){
      this.environmentName = environment.environmentName;
    }

  ngOnInit(): void {
     this.fullname = this.userContext.fullName();
     this.username = this.userContext.username();
  }

  onMenuClosed(isOpen: boolean): void {
    this.visibleMenuSwitcher = isOpen; 
  }

  logout = () => {
    localStorage.clear();
    this.userContext.logout();
  }
}
